import { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import useFetch from '../../../../components/hooks/useFetch';
import Input from '../../../../components/form/Input';
import { getIPAddress } from '../../../../components/utils/GetIPAddress';
import { SISTEMA_AUTORIZADO_PERMISSIONARIO } from '../../../../services/delegacaoTerceiro';
import { PESQUISAR_SISTEMAS_PJ } from '../../../../services/delegacao';
import { abreAlertaDialog } from '../../../../components/modal/AlertaDialog';

const FormPermissaoSistema = ({ acaoCancelar, dados, terceiro }) => {
  const methods = useForm({});
  const [itensAutorizados, setItensAutorizados] = useState([]);
  const [montarSistemas, setMontarSistemas] = useState(false);

  const [ipAddress, setIpAddress] = useState('');
  const { request } = useFetch();
  const { request: requestSistema, data: dadosSistema } = useFetch();
  const formMethods = {
    inputRef: methods.register,
    errors: methods.errors,
    control: methods.control,
    watch: methods.watch,
  };
  useEffect(() => {
    const fetchIPAddress = async () => {
      const ip = await getIPAddress();
      const port = window.location.port;
      setIpAddress(ip + ':' + port);
    };
    fetchIPAddress();
  }, []);
  useEffect(() => {
    setMontarSistemas(false);
    if (!dadosSistema?.length > 0)
      requestSistema(PESQUISAR_SISTEMAS_PJ(dados.idCorreios, dados.tipo));
  }, [terceiro]);

  useEffect(() => {
    if (terceiro?.sistemas) {
      var dadosAutorizados;

      if (itensAutorizados == undefined) {
        dadosAutorizados = [];
      } else {
        dadosAutorizados = itensAutorizados;
      }
      dadosSistema?.forEach((sistema, i) => {
        const existe = terceiro.sistemas.some(
          (terceiro) => terceiro === sistema.id,
        );
        dadosAutorizados[i] = existe;
      });
      setItensAutorizados(dadosAutorizados);
    } else {
      setItensAutorizados(dadosSistema?.map(() => false));
    }
    if (dadosSistema) setMontarSistemas(true);
  }, [terceiro]);
  const cancelar = () => {
    acaoCancelar();
  };
  const handleCheckBoxChange = (id) => {
    const atualizaItensMarcados = [...itensAutorizados];
    atualizaItensMarcados[id] = !atualizaItensMarcados[id];
    setItensAutorizados(atualizaItensMarcados);
  };
  const autorizar = async () => {
    var autorizacoes = [];
    itensAutorizados.forEach((item, i) => {
      autorizacoes[i] = {
        idCorreios: dados.idCorreios,
        idCorreiosPF: terceiro.idCorreiosPF,
        coSistema: dadosSistema[i].id,
        autoriza: item,
        tipo: dados.tipo,
      };
      acaoCancelar();
    });

    const { response } = await request(
      SISTEMA_AUTORIZADO_PERMISSIONARIO(autorizacoes, ipAddress),
    );
    if (response.ok) {
      abreAlertaDialog('Autorizacao efetuada com sucesso.');
    }
  };
  return (
    <>
      {dadosSistema?.length === 0 || dadosSistema == undefined ? (
        <h6>Não foram encontrados sistemas para autorizar</h6>
      ) : (
        <>
          <h6>Selecione os sistemas que deseja autorizar</h6>
          <div className="dialog-main">
            {montarSistemas && (
              <>
                {dadosSistema?.map((item, index) => (
                  <div className="toggle-container">
                    <label className="toggle">
                      <Input
                        className="toggle-checkbox esconder-visualmente"
                        type="checkbox"
                        name={item.iprojTi?.sigla}
                        onChange={() => handleCheckBoxChange(index)}
                        checked={itensAutorizados[index] || false}
                        {...formMethods}
                      />
                      <div className="toggle-switch"></div>
                      <span className="toggle-label">
                        {item.iprojTi?.sigla}
                      </span>
                    </label>
                  </div>
                ))}
              </>
            )}
          </div>
        </>
      )}
      <div className="dialog-footer btns-row-fixo">
        <button className="btn-txt btn-fecha-dialog" onClick={() => cancelar()}>
          Cancelar
        </button>
        {dadosSistema?.length > 0 && (
          <button className="btn-pre btn-com-icone" onClick={() => autorizar()}>
            <i className="ic-usuario-visto"></i>
            Autorizar
          </button>
        )}
      </div>
    </>
  );
};
export default FormPermissaoSistema;
